




























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
    components: {
        cardTabbed: () => import('../../components/shared/CardTabbed.vue'),
        cctvhistory: () => import('../../views/content/CCTVHistory.vue'),
        surveyhistory: () => import('../../views/content/SurveyHistory.vue'),
        surveyqueue: () => import('../../views/content/SurveyQueue.vue'),
        assetlocator: () => import('../../views/content/AssetLocator.vue')
    }
})
export default class TabbedView extends Vue {

    @Prop(Object) network!: any

    CODES : string[] = [ 'WW', 'SW', 'WS' ]
    activeTab: string = ''
    loadedTabs: Set<string> = new Set()

    mounted() {
        // Set the first tab as active by default
        if (this.network && this.network.options && this.network.options.length > 0) {
            this.activeTab = this.network.options[0].title
            this.loadedTabs.add(this.activeTab)
        }
    }

    onTabChange(tabTitle: string) {
        this.activeTab = tabTitle
        this.loadedTabs.add(tabTitle)
    }

    isTabActive(tab: any): boolean {
        const isActive = this.activeTab === tab.title
        return isActive
    }

    showHistoryComponent(network: any, props: any) {
        if(this.CODES.indexOf(network.code) > -1 && props.tab.component === 'surveyhistory') {
            return true
        }
        return false
    }

    showQueueComponent(network: any, props: any) {
        if(this.CODES.indexOf(network.code) > -1 && props.tab.component === 'surveyqueue') {
            return true
        }
        return false
    }

    showSurveyHistory(network: any, props: any) {
        if(network.code==='cctv' && props.tab.component != 'assetlocator') {
            return true
        }
        return false
    }

    showAssetLocator(network: any, props: any) {
        if(props.tab.component === 'assetlocator') {
            return true
        }
        return false
    }

}
